/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Dashboard_With_ExtrasInputs */

const en_admin_dashboard_with_extras = /** @type {(inputs: Admin_Dashboard_With_ExtrasInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} with Extras`)
};

const de_admin_dashboard_with_extras = /** @type {(inputs: Admin_Dashboard_With_ExtrasInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} mit Extras`)
};

const es_admin_dashboard_with_extras = /** @type {(inputs: Admin_Dashboard_With_ExtrasInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} con extras`)
};

const fr_admin_dashboard_with_extras = /** @type {(inputs: Admin_Dashboard_With_ExtrasInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} avec extras`)
};

const nl_admin_dashboard_with_extras = /** @type {(inputs: Admin_Dashboard_With_ExtrasInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} met extras`)
};

const ro_admin_dashboard_with_extras = /** @type {(inputs: Admin_Dashboard_With_ExtrasInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} cu Extra-uri`)
};

/** @type {(inputs: Admin_Dashboard_With_ExtrasInputs) => LocalizedString} */
const it_admin_dashboard_with_extras = en_admin_dashboard_with_extras;

/** @type {(inputs: Admin_Dashboard_With_ExtrasInputs) => LocalizedString} */
const pt_br2_admin_dashboard_with_extras = en_admin_dashboard_with_extras;

/** @type {(inputs: Admin_Dashboard_With_ExtrasInputs) => LocalizedString} */
const pl_admin_dashboard_with_extras = en_admin_dashboard_with_extras;

/** @type {(inputs: Admin_Dashboard_With_ExtrasInputs) => LocalizedString} */
const hu_admin_dashboard_with_extras = en_admin_dashboard_with_extras;

/**
* | output |
* | --- |
* | "{count} with Extras" |
*
* @param {Admin_Dashboard_With_ExtrasInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_with_extras = /** @type {((inputs: Admin_Dashboard_With_ExtrasInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_With_ExtrasInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_with_extras(inputs)
	if (locale === "de") return de_admin_dashboard_with_extras(inputs)
	if (locale === "es") return es_admin_dashboard_with_extras(inputs)
	if (locale === "fr") return fr_admin_dashboard_with_extras(inputs)
	if (locale === "nl") return nl_admin_dashboard_with_extras(inputs)
	if (locale === "it") return it_admin_dashboard_with_extras(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_with_extras(inputs)
	if (locale === "pl") return pl_admin_dashboard_with_extras(inputs)
	if (locale === "hu") return hu_admin_dashboard_with_extras(inputs)
	return ro_admin_dashboard_with_extras(inputs)
});
export { admin_dashboard_with_extras as "admin.dashboard.with_extras" }